import { Group, ScrollArea, UnstyledButton } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';

/**
 * Horizontal, swipeable section switcher for the admin area — a mobile
 * pattern that scales better than a sidebar as more admin screens are added.
 */
export const AdminSubNav = () => {
  const { t } = useTranslation();
  const ADMIN_SECTIONS = [
    { to: '/admin', label: t('admin.subnav.catalog'), end: true },
    { to: '/admin/daily', label: t('admin.subnav.daily') },
    { to: '/admin/monthly', label: t('admin.subnav.monthly') },
    { to: '/admin/users', label: t('admin.subnav.users') },
    { to: '/admin/audit-log', label: t('admin.subnav.auditLog') },
  ];

  return (
    <ScrollArea scrollbarSize={0} type="never">
      <Group
        gap={0}
        px="md"
        style={{ borderBottom: '1px solid var(--mantine-color-ink-3)', flexShrink: 0 }}
        wrap="nowrap"
      >
        {ADMIN_SECTIONS.map((section) => (
          <NavLink end={section.end} key={section.to} to={section.to}>
            {({ isActive }) => (
              <UnstyledButton
                c={isActive ? 'signal.7' : 'ink.7'}
                ff="monospace"
                fw={700}
                px="xs"
                py="sm"
                style={{
                  backgroundColor: isActive ? 'var(--mantine-color-signal-0)' : 'transparent',
                  borderBottom: isActive
                    ? '3px solid var(--mantine-color-signal-6)'
                    : '3px solid transparent',
                  fontSize: '0.6875rem',
                  letterSpacing: '0.08em',
                  marginBottom: -1,
                  transition: 'background-color 120ms ease, color 120ms ease',
                  whiteSpace: 'nowrap',
                }}
              >
                <Group gap={8} pr="md">
                  {section.label}
                </Group>
              </UnstyledButton>
            )}
          </NavLink>
        ))}
      </Group>
    </ScrollArea>
  );
};
